import React, { useEffect } from 'react';
import { Drawer, makeStyles, useMediaQuery } from '@material-ui/core';
import { useTheme } from 'styled-components';

import { SvgIcon } from 'Components/Base';
import { useDisclosure } from 'Util/Hooks';

import Sidebar from './Sidebar';

const useStyles = makeStyles(() => ({
  paper: {
    overflow: 'hidden',
  },
}));

const Hamburger = (props) => {
  const [isOpen, onOpen, onClose] = useDisclosure();
  const theme = useTheme();
  const isDesktop = useMediaQuery(`(min-width:${theme?.breakpoints?.lg ?? '1024px'})`);
  const classes = useStyles();

  useEffect(() => {
    if (isDesktop && isOpen) onClose();
  }, [isOpen, isDesktop, onClose]);

  return (
    <>
      <SvgIcon
        icon={SvgIcon.ICON_LIST.MENU_BURGER}
        size={24}
        color={'primary'}
        style={{ cursor: 'pointer', zIndex: 1 }}
        onClick={onOpen}
        data-testid={`btn-mycourse-hamburger-menu`}
        {...props}
      />
      <Drawer open={isOpen} onClose={onClose} classes={classes}>
        <Sidebar />
      </Drawer>
    </>
  );
};

export default Hamburger;
